<template>
  <div id="proposalModal" aria-labelledby="proposalModalLabel1" class="modal fade CAB" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 id="exampleModalLabel1" class="modal-title">
            Proposal
          </h4>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="proposal" class="row">
            <div class="col-sm-12">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6 text-left">
                      <h4>Proposal ID</h4>
                      <p>{{ proposal.proposal_id }}</p>
                    </div>
                    <div class="col-md-6 text-right">
                      <h4>Description</h4>
                      <p>
                        {{ proposal.module }}<span v-if="proposal.description">:&nbsp;{{ proposal.description }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 text-left">
                      <h4>Comments</h4>
                      <p>
                        {{ proposal.comments }}
                      </p>
                    </div>
                    <div class="col-md-6 text-right">
                      <h4>Transaction</h4>
                      <p>
                        <a target="_blank" :href="$BORLAUG + '/proposals/' + proposal.proposal_id"><img src="@/assets/images/orange_bws_logo.png" class="bws-ico"> Borlaug</a>
                      </p>
                    </div>
                  </div>
                  <div v-if="proposal.votes && proposal.votes.threshold > 1" class="row">
                    <table class="table table-bordered">
                      <tr>
                        <th class="p-2 font-bold">
                          Voters
                        </th>
                        <th class="p-2 font-bold">
                          Status
                        </th>
                      </tr>
                      <tr v-for="(voter, index) in proposal.voters" :key="index">
                        <td class="p-2">
                          <address-book-by-public-key :public-key="voter" />
                        </td>
                        <td>
                          <button class="btn btn-success" type="button">
                            <i class="fa fa-thumbs-up" />
                          </button>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div v-else class="row">
                    <div class="col-md-12 text-left">
                      <h4>Created By</h4>
                      <p>
                        <address-book-by-public-key :public-key="proposal.created_by" />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="card-body">
            <h4 class="card-title text-muted text-center">
              No record found
            </h4>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn waves-effect waves-light btn-secondary" data-dismiss="modal" type="button">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddressBookByPublicKey from './AddressBookByPublicKey.vue'

export default {
  name: 'ProposalStat',
  components: { AddressBookByPublicKey },
  props: ['proposal']
}
</script>

<style scoped>
</style>
